export default __webpack_public_path__ + "static/media/Sakuracon.63dc6a4b.png";